import { t } from '@lingui/core/macro';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import {
  SettingsSection,
  SettingsSectionSkeleton,
} from './-components/settings-section';
import { TeamsPanel } from './-components/teams/teams-panel';
import { SETTINGS_HELP } from './-utils/help-articles';
import { teamsOverviewQueryOptions } from './-utils/teams-query';

export const Route = createFileRoute(
  '/researchers/_authenticated/settings/teams',
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      teamsOverviewQueryOptions(context.user.id),
    ),
  pendingComponent: SettingsSectionSkeleton,
  component: TeamsPage,
  head: () => ({ meta: [{ title: t`Your teams` }] }),
});

function TeamsPage() {
  const { user, activeDashboard } = Route.useRouteContext();
  const { data: overview } = useSuspenseQuery(
    teamsOverviewQueryOptions(user.id),
  );

  return (
    <SettingsSection
      helpUrl={SETTINGS_HELP.teams}
      title={t`Your teams`}
      description={t`Switch between your teams, ask to join others, and review requests.`}
    >
      <TeamsPanel
        overview={overview}
        userId={user.id}
        activeDashboard={activeDashboard}
      />
    </SettingsSection>
  );
}
